import { create } from 'zustand';
import { authSDK } from '@pana-tech/auth-sdk';

type AuthState = {
    oauthToken?: string;
    createOAuthToken: (scope?: string[]) => Promise<void>;
};

const useAuthStore = create<AuthState>((set) => ({
    oauthToken: undefined,
    createOAuthToken: async (scope) => {
        const clientId = process.env.REACT_APP_OAUTH_CLIENT_ID!;
        const clientSecret = process.env.REACT_APP_OAUTH_CLIENT_SECRET!;
        const baseUrl = process.env.REACT_APP_OAUTH_URL!;
        const response = await authSDK.oauth.createToken({
            data: {
                clientId,
                clientSecret,
                scope: scope?.join(' '),
            },
            config: { baseUrl },
        });
        if (!response) return;
        const { accessToken } = response;
        set({ oauthToken: accessToken });
    },
}));

export { useAuthStore };
